import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import Badge from "components/Badge";
import NotificationIcon from "./components/NotificationIcon";

import {grey300, greyishBlue900} from "assets/jss/main";

NotificationSidebarItem.propTypes = {
    onClick: PropTypes.func,
    notificationsNotViewedCount: PropTypes.number
};

function NotificationSidebarItem({onClick = () => {}, notificationsNotViewedCount = 0}) {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <div
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={onClick}
            style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '8px',
                cursor: 'pointer',
                borderRadius: '8px',
                background: isHovered ? grey300 : 'white',
            }}
        >
            <div style={{
                display: 'flex',
                alignItems: 'center',
            }}>
                <NotificationIcon notificationCount={notificationsNotViewedCount} />
                <span style={{
                    marginLeft:'8px',
                    marginRight: '8px',
                    color: greyishBlue900,
                    fontSize: '14px',
                    fontWeight: 600
                }}>
                    <FormattedMessage id='sidebar.profil.notification.title' />
                </span>
            </div>
            <div>
                <Badge color={notificationsNotViewedCount > 0 ? "error" : "default"} rounded={true}>{notificationsNotViewedCount}</Badge>
            </div>
        </div>
    );
}

export default NotificationSidebarItem;
